import {Box} from '@mui/material';
import {
  YSBorderState,
  YSThemeStyleRadius,
} from 'main/utility/AppContextProvider/YSTheme';
import PropsTypes from 'prop-types';

const MainContent = ({children, ...rest}) => {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        ml: {lg: '280px'},
        width: {xs: '100%', lg: `calc(100% - 280px)`},
        flexDirection: 'column',
        position: 'relative',
        transition: 'all 0.5s ease',
        height: '100vh',
        overflowY: 'auto',
        overflowX: 'hidden',

        // Rebranding
        '&::-webkit-scrollbar': {
          width: '8px',
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: (theme) => theme.palette.background.default,
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: YSBorderState.default,
          borderRadius: YSThemeStyleRadius.STANDARD,
          '&:hover': {
            backgroundColor: YSBorderState.hover,
          },
          // Firefox Support
          scrollbarWidth: 'thin',
          scrollbarColor: `${YSBorderState.default} transparent`,
        },
      }}
      className='mainContent'
      {...rest}
    >
      {children}
    </Box>
  );
};

export default MainContent;

MainContent.propTypes = {
  children: PropsTypes.node,
};
